"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Annotations_1 = require("./Annotations");
var ImageSlider_1 = __importStar(require("./ImageSlider"));
var SizeChartComponent_1 = __importDefault(require("./SizeChartComponent"));
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDimensions = function () {
            var sizeChartMaxHeight = _this.getSizeChartHeight(window.innerHeight, window.innerWidth);
            var imageMaxDimension = _this.getImageMaxDimension(window.innerHeight, window.innerWidth);
            _this.setState({ sizeChartMaxHeight: sizeChartMaxHeight, imageMaxDimension: imageMaxDimension });
        };
        _this.getSizeChartHeight = function (windowHeight, windowWidth) {
            var thinScreen = windowWidth < 800;
            if (thinScreen) {
                var mobileOffset = 100;
                return (windowHeight / 2) - mobileOffset;
            }
            var desktopOffset = 225;
            return windowHeight - desktopOffset;
        };
        _this.getImageMaxDimension = function (windowHeight, windowWidth) {
            var thinScreen = windowWidth < 800;
            var offset = 20;
            if (thinScreen) {
                return Math.max(300, Math.min(windowWidth - offset, windowHeight / 2 - offset));
            }
            return undefined;
        };
        _this.nextImage = function () {
            var images = _this.props.images;
            var length = images.length;
            var nextIndex = (_this.state.currentImageIndex + 1) % length;
            _this.setState({ currentImageIndex: nextIndex });
        };
        _this.previousImage = function () {
            var images = _this.props.images;
            var length = images.length;
            var previousIndex = (_this.state.currentImageIndex - 1 + length) % length;
            _this.setState({ currentImageIndex: previousIndex });
        };
        _this.selectImage = function (imageIndex) {
            _this.setState({ currentImageIndex: imageIndex });
        };
        _this.handleKeyPress = function (ev) {
            ev.stopPropagation();
            var ESC = 27;
            var RIGHT = 39;
            var LEFT = 37;
            if (ev.keyCode === ESC) {
                return _this.props.hideSizeChartFn();
            }
            if (ev.keyCode === LEFT) {
                return _this.previousImage();
            }
            if (ev.keyCode === RIGHT) {
                return _this.nextImage();
            }
        };
        var sizeChartMaxHeight = _this.getSizeChartHeight(window.innerHeight, window.innerWidth);
        var imageMaxDimension = _this.getImageMaxDimension(window.innerHeight, window.innerWidth);
        _this.state = {
            currentImageIndex: props.initialImageIndex,
            sizeChartMaxHeight: sizeChartMaxHeight,
            imageMaxDimension: imageMaxDimension,
        };
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        document.addEventListener("keydown", this.handleKeyPress);
        window.addEventListener("resize", this.updateDimensions);
    };
    Modal.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.handleKeyPress);
        window.removeEventListener("resize", this.updateDimensions);
    };
    Modal.prototype.render = function () {
        var _a = this.props, zIndex = _a.zIndex, images = _a.images, displayUnit = _a.displayUnit, toggleDisplayUnit = _a.toggleDisplayUnit, displayVariantId = _a.displayVariantId, sizeChart = _a.sizeChart, hideSizeChartFn = _a.hideSizeChartFn, graphics = _a.graphics, defaultOptions = _a.defaultOptions, optionLabels = _a.optionLabels, optionsToVariantId = _a.optionsToVariantId, optionChoices = _a.optionChoices;
        var _b = this.state, currentImageIndex = _b.currentImageIndex, sizeChartMaxHeight = _b.sizeChartMaxHeight, imageMaxDimension = _b.imageMaxDimension;
        var _c = this, nextImage = _c.nextImage, previousImage = _c.previousImage, selectImage = _c.selectImage;
        return React.createElement("div", { className: "ma-popup-container", style: { zIndex: zIndex } },
            React.createElement("div", { className: "ma-popup" },
                React.createElement("div", { className: "ma-image-slide-container ma-column" },
                    React.createElement(ImageSlider_1.default, { images: images, imageIndex: currentImageIndex, showImagePreviews: false, imagePreviewPosition: ImageSlider_1.PreviewPosition.DOWN, nextImage: nextImage, previousImage: previousImage, selectImage: selectImage, displayUnit: displayUnit, canToggleDisplayUnit: false, toggleDisplayUnit: toggleDisplayUnit, displayVariantId: displayVariantId, sizeChart: sizeChart, canToggleSizeChart: false, showSizeChartAction: function () { return undefined; }, annotationsDisplay: Annotations_1.AnnotationsDisplay.SHOW_LABELS, canToggleGraphics: false, showGraphics: function () { return undefined; }, hideGraphics: function () { return undefined; }, toggleActionButtonsOnHover: false, graphics: graphics, imageMaxDimension: imageMaxDimension, zoomable: false, largeScreen: true, enableSliderArrows: true, showExpiredNotice: false })),
                React.createElement("div", { className: "ma-size-chart-container ma-column" },
                    React.createElement(SizeChartComponent_1.default, { displayUnit: displayUnit, toggleDisplayUnit: toggleDisplayUnit, sizeChart: sizeChart, hideSizeChartFn: hideSizeChartFn, graphics: graphics, defaultOptions: defaultOptions, optionLabels: optionLabels, optionsToVariantId: optionsToVariantId, labelsToOptions: optionChoices, maxHeight: sizeChartMaxHeight }))));
    };
    return Modal;
}(React.PureComponent));
exports.default = Modal;
